/**
 * diameter-range.js  v5
 * Native stacked range inputs + client-side metafield range filters (diameter, inhoud, hoogtecm)
 */

const METAFIELD_RANGE_CONFIGS = [
  {
    key: 'diametercm',
    paramGte: 'filter.p.m.custom.diametercm.gte',
    paramLte: 'filter.p.m.custom.diametercm.lte',
    attr: 'diametercm'
  },
  {
    key: 'inhoud',
    paramGte: 'filter.p.m.custom.inhoud.gte',
    paramLte: 'filter.p.m.custom.inhoud.lte',
    attr: 'inhoud'
  },
  {
    key: 'hoogtecm',
    paramGte: 'filter.p.m.custom.hoogtecm.gte',
    paramLte: 'filter.p.m.custom.hoogtecm.lte',
    attr: 'hoogtecm'
  }
];

function getRangeParamsFromUrl(paramGte, paramLte) {
  const p = new URLSearchParams(window.location.search);
  const gte = p.get(paramGte);
  const lte = p.get(paramLte);
  return {
    gte: gte !== null && gte !== '' ? parseFloat(gte) : null,
    lte: lte !== null && lte !== '' ? parseFloat(lte) : null
  };
}

function format1(n) {
  const x = typeof n === 'number' ? n : parseFloat(n);
  return Number.isFinite(x) ? x.toFixed(1) : '';
}

function applyMetafieldFiltersToGrid() {
  const productList = document.querySelector('.collection__results product-list, .product-list');
  if (!productList) return;

  const cards = productList.querySelectorAll('product-card');
  cards.forEach((card) => {
    let visible = true;

    METAFIELD_RANGE_CONFIGS.forEach(cfg => {
      if (!visible) return;

      const { gte, lte } = getRangeParamsFromUrl(cfg.paramGte, cfg.paramLte);
      const hasFilter = gte !== null || lte !== null;
      if (!hasFilter) return;

      const raw = card.getAttribute(`data-${cfg.attr}`);
      const val = raw !== null && raw !== '' ? parseFloat(raw) : NaN;
      if (isNaN(val)) {
        visible = false;
        return;
      }

      if ((gte !== null && val < gte) || (lte !== null && val > lte)) {
        visible = false;
      }
    });

    card.style.display = visible ? '' : 'none';
  });
}

function updateMetafieldActiveChips() {
  const currentUrl = new URL(window.location.href);

  // Collect all active metafield ranges first
  const activeConfigs = METAFIELD_RANGE_CONFIGS.map(cfg => {
    const { gte, lte } = getRangeParamsFromUrl(cfg.paramGte, cfg.paramLte);
    return { cfg, gte, lte };
  }).filter(item => item.gte !== null || item.lte !== null);

  // If no metafield ranges are active, just remove our chips and exit
  const existingContainer = document.querySelector('.collection__top-bar .active-facets, .facets-summary .active-facets');
  if (activeConfigs.length === 0) {
    if (existingContainer) {
      existingContainer.querySelectorAll('[data-metafield-chip]').forEach(el => el.remove());
    }
    return;
  }

  // Prefer the theme's existing active-facets container inside the facets summary
  let container = existingContainer;
  if (!container) {
    const summary = document.querySelector('.collection__top-bar .facets-summary');
    if (!summary) return;
    container = document.createElement('div');
    container.className = 'active-facets';
    summary.appendChild(container);
  }

  // Remove previously added metafield chips (keep Shopify's own chips)
  container.querySelectorAll('[data-metafield-chip]').forEach(el => el.remove());

  activeConfigs.forEach(({ cfg, gte, lte }) => {
    const prettyKey = cfg.key === 'hoogtecm'
      ? 'Hoogte (cm)'
      : (cfg.key === 'diametercm' ? 'Diameter (cm)' : cfg.key.charAt(0).toUpperCase() + cfg.key.slice(1));

    let labelText;
    if (gte !== null && lte !== null) {
      labelText = `${prettyKey}: ${format1(gte)} – ${format1(lte)}`;
    } else if (gte !== null) {
      labelText = `${prettyKey}: ≥ ${format1(gte)}`;
    } else {
      labelText = `${prettyKey}: ≤ ${format1(lte)}`;
    }

    const chip = document.createElement('div');
    chip.className = 'removable-facet';
    chip.setAttribute('data-metafield-chip', cfg.key);

    const textNode = document.createTextNode(labelText);
    chip.appendChild(textNode);

    const clearUrl = new URL(currentUrl.toString());
    clearUrl.searchParams.delete(cfg.paramGte);
    clearUrl.searchParams.delete(cfg.paramLte);

    const a = document.createElement('a');
    a.href = clearUrl.toString();
    a.setAttribute('is', 'facet-link');
    a.className = 'tap-area';
    a.setAttribute('aria-label', `Remove filter ${prettyKey}`);
    a.setAttribute('data-no-instant', '');
    a.textContent = '×';

    chip.appendChild(a);
    container.appendChild(chip);
  });
}

// Hide/adjust pagination when client-side metafield filters are active
function updatePaginationForMetafields() {
  const { gte: d1, lte: d2 } = getRangeParamsFromUrl('filter.p.m.custom.diametercm.gte','filter.p.m.custom.diametercm.lte');
  const { gte: i1, lte: i2 } = getRangeParamsFromUrl('filter.p.m.custom.inhoud.gte','filter.p.m.custom.inhoud.lte');
  const { gte: h1, lte: h2 } = getRangeParamsFromUrl('filter.p.m.custom.hoogtecm.gte','filter.p.m.custom.hoogtecm.lte');
  const anyActive = (d1!==null||d2!==null||i1!==null||i2!==null||h1!==null||h2!==null);
  const pagination = document.querySelector('.collection__pagination.pagination, .collection__pagination');
  const productList = document.querySelector('.collection__results product-list, .product-list');
  if (!pagination || !productList) return;

  // Remove any previous empty message
  document.getElementById('mf-empty')?.remove();

  if (!anyActive) {
    pagination.style.display = '';
    return;
  }

  const visibleCards = Array.from(productList.querySelectorAll('product-card')).filter(el => el.style.display !== 'none');
  if (visibleCards.length === 0) {
    pagination.style.display = 'none';
    const empty = document.createElement('div');
    empty.id = 'mf-empty';
    empty.className = 'prose text-center my-8';
    empty.textContent = 'Geen producten gevonden voor deze filter.';
    productList.parentElement?.appendChild(empty);
    return;
  }

  // Hide server pagination to avoid misleading counts when client-side filter is active
  pagination.style.display = 'none';
}

class DiameterRange extends HTMLElement {

    connectedCallback() {
      requestAnimationFrame(() => this._init());
    }

    _init() {
      this.rangeLo = this.querySelector('.dr-range--lo');
      this.rangeHi = this.querySelector('.dr-range--hi');
      this.numLo   = this.querySelector('.dr-num--lo');
      this.numHi   = this.querySelector('.dr-num--hi');
      this.fill    = this.querySelector('.dr-track-fill');

      if (!this.rangeLo || !this.rangeHi) {
        console.warn('[diameter-range] Slider inputs not found');
        return;
      }

      this.ABS_MIN   = parseFloat(this.dataset.absMin);
      this.ABS_MAX   = parseFloat(this.dataset.absMax);
      this.SPAN      = (this.ABS_MAX - this.ABS_MIN) || 1;
      this.PARAM_GTE = this.dataset.paramGte;
      this.PARAM_LTE = this.dataset.paramLte;
      this._timer    = null;

      this.vLo = parseFloat(this.dataset.curMin);
      this.vHi = parseFloat(this.dataset.curMax);

      const { gte, lte } = getRangeParamsFromUrl(this.PARAM_GTE, this.PARAM_LTE);
      if (gte !== null && !isNaN(gte)) this.vLo = Math.max(this.ABS_MIN, Math.min(gte, this.ABS_MAX));
      if (lte !== null && !isNaN(lte)) this.vHi = Math.min(this.ABS_MAX, Math.max(lte, this.ABS_MIN));
      if (this.vLo > this.vHi) this.vLo = this.vHi;

      // If this range has active URL params, open its accordion visually
      if (gte !== null || lte !== null) {
        const filterEl = this.closest('.dr-filter');
        if (filterEl) {
          const header = filterEl.querySelector('.dr-filter__header');
          const body = filterEl.querySelector('.dr-filter__body');
          if (header) {
            header.setAttribute('aria-expanded', 'true');
            const chev = header.querySelector('.dr-chevron');
            if (chev) chev.classList.add('dr-chevron--up');
          }
          if (body) {
            body.classList.remove('dr-filter__body--closed');
          }
        }
      }

      console.log('[metafield-range:init]', {
        paramGte: this.PARAM_GTE,
        paramLte: this.PARAM_LTE,
        absMin: this.ABS_MIN,
        absMax: this.ABS_MAX,
        vLo: this.vLo,
        vHi: this.vHi
      });

      [this.rangeLo, this.rangeHi].forEach(el => {
        el.min = this.ABS_MIN;
        el.max = this.ABS_MAX;
        el.step = '0.1';
      });
      this.rangeLo.value = format1(this.vLo);
      this.rangeHi.value = format1(this.vHi);
      if (this.numLo) {
        this.numLo.min = this.ABS_MIN;
        this.numLo.max = this.ABS_MAX;
        this.numLo.step = '0.1';
        this.numLo.value = format1(this.vLo);
      }
      if (this.numHi) {
        this.numHi.min = this.ABS_MIN;
        this.numHi.max = this.ABS_MAX;
        this.numHi.step = '0.1';
        this.numHi.value = format1(this.vHi);
      }

      this._updateFill();
      this._bindEvents();
      this._syncNames();
    }
  
    _bindEvents() {
      // ── Sliders (native drag — always works) ──────────
      this.rangeLo.addEventListener('input', () => {
        this.vLo = parseFloat(this.rangeLo.value);
        // Prevent crossover
        if (this.vLo > this.vHi) {
          this.vLo = this.vHi;
          this.rangeLo.value = this.vLo;
        }
        if (this.numLo) this.numLo.value = format1(this.vLo);
        this._updateFill();
        this._syncNames();
        console.log('[metafield-range:input-lo]', this.PARAM_GTE, this.vLo);
        this._debounce();
      });
  
      this.rangeHi.addEventListener('input', () => {
        this.vHi = parseFloat(this.rangeHi.value);
        if (this.vHi < this.vLo) {
          this.vHi = this.vLo;
          this.rangeHi.value = this.vHi;
        }
        if (this.numHi) this.numHi.value = format1(this.vHi);
        this._updateFill();
        this._syncNames();
        console.log('[metafield-range:input-hi]', this.PARAM_LTE, this.vHi);
        this._debounce();
      });
  
      // ── Number inputs ──────────────────────────────────
      if (this.numLo) {
        this.numLo.addEventListener('change', () => {
          let v = parseFloat(this.numLo.value);
          if (isNaN(v)) v = this.ABS_MIN;
          v = Math.max(this.ABS_MIN, Math.min(v, this.vHi));
          this.vLo = v;
          this.numLo.value  = format1(v);
          this.rangeLo.value = format1(v);
          this._updateFill();
          this._syncNames();
          console.log('[metafield-range:change-lo]', this.PARAM_GTE, this.vLo);
          this._debounce();
        });
      }
  
      if (this.numHi) {
        this.numHi.addEventListener('change', () => {
          let v = parseFloat(this.numHi.value);
          if (isNaN(v)) v = this.ABS_MAX;
          v = Math.min(this.ABS_MAX, Math.max(v, this.vLo));
          this.vHi = v;
          this.numHi.value  = format1(v);
          this.rangeHi.value = format1(v);
          this._updateFill();
          this._syncNames();
          console.log('[metafield-range:change-hi]', this.PARAM_LTE, this.vHi);
          this._debounce();
        });
      }
    }
  
    // Update the colored fill bar between thumbs
    _updateFill() {
      if (!this.fill) return;
      const lo = ((this.vLo - this.ABS_MIN) / this.SPAN * 100).toFixed(2);
      const hi = ((this.vHi - this.ABS_MIN) / this.SPAN * 100).toFixed(2);
      this.fill.style.left  = lo + '%';
      this.fill.style.right = (100 - hi) + '%';
    }

    _syncNames() {
      if (!this.rangeLo || !this.rangeHi) return;
      const isFullRange = this.vLo <= this.ABS_MIN && this.vHi >= this.ABS_MAX;
      if (isFullRange) {
        this.rangeLo.name = '';
        this.rangeHi.name = '';
      } else {
        this.rangeLo.name = this.PARAM_GTE;
        this.rangeHi.name = this.PARAM_LTE;
      }
    }
  
    _debounce() {
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this._navigate(), 450);
    }
  
    _navigate() {
      // If theme uses a facets form, let it handle
      const form = this.closest('form[data-type="facets"]') || this.closest('form');
      if (form) {
        form.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
  
      const url = new URL(window.location.href);
      const p   = url.searchParams;
  
      // Delete first → no duplicate params ever
      p.delete(this.PARAM_GTE);
      p.delete(this.PARAM_LTE);
      p.delete('page');
  
      if (this.vLo > this.ABS_MIN) p.set(this.PARAM_GTE, format1(this.vLo));
      if (this.vHi < this.ABS_MAX) p.set(this.PARAM_LTE, format1(this.vHi));

      console.log('[metafield-range:navigate]', {
        url: url.toString(),
        paramGte: this.PARAM_GTE,
        paramLte: this.PARAM_LTE,
        vLo: this.vLo,
        vHi: this.vHi
      });
  
      window.location.href = url.toString();
    }
  }
  
  if (!customElements.get('diameter-range')) {
    customElements.define('diameter-range', DiameterRange);
  }
  
  // Accordion toggle
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-dr-filter] .dr-filter__header');
    if (!btn) return;
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    const body = document.getElementById(btn.getAttribute('aria-controls'));
    if (body) body.classList.toggle('dr-filter__body--closed', open);
    btn.querySelector('.dr-chevron')?.classList.toggle('dr-chevron--up', !open);
  });

  // Client-side metafield filters (Shopify has no storefront range for metafields)
  function runMetafieldFilters() {
    requestAnimationFrame(() => {
      applyMetafieldFiltersToGrid();
      updateMetafieldActiveChips();
      updatePaginationForMetafields();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runMetafieldFilters);
  } else {
    runMetafieldFilters();
  }

  // When Shopify's AJAX facets update the collection section, the DOM is replaced
  // asynchronously after the "facet:update" event is dispatched. Delay our
  // re-filtering slightly so it runs on the new DOM, not the old one.
  document.addEventListener('facet:update', () => {
    setTimeout(runMetafieldFilters, 400);
  });

  // Also observe DOM replacements and re-run when the product grid changes.
  // This is more reliable than a fixed timeout on some themes/configurations.
  function startCollectionObserver() {
    const section = document.querySelector('.shopify-section');
    if (!section || window.__mfRangeObserver) return;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
          // If the product list is added/replaced, re-apply filters immediately.
          if (document.querySelector('.collection__results product-list, .product-list')) {
            runMetafieldFilters();
          }
        }
      }
    });
    observer.observe(section, { childList: true, subtree: true });
    window.__mfRangeObserver = observer;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCollectionObserver, { once: true });
  } else {
    startCollectionObserver();
  }

  // Handle back/forward navigation restoring params
  window.addEventListener('popstate', () => {
    runMetafieldFilters();
  });
